var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSixDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05418 6.05759C1.63639 6.05759 2.10837 5.58561 2.10837 5.0034C2.10837 4.42119 1.63639 3.94922 1.05418 3.94922C0.471974 3.94922 0 4.42119 0 5.0034C0 5.58561 0.471974 6.05759 1.05418 6.05759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05418 2.10837C1.63639 2.10837 2.10837 1.63639 2.10837 1.05418C2.10837 0.471974 1.63639 0 1.05418 0C0.471974 0 0 0.471974 0 1.05418C0 1.63639 0.471974 2.10837 1.05418 2.10837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05418 9.99899C1.63639 9.99899 2.10837 9.52702 2.10837 8.94481C2.10837 8.3626 1.63639 7.89062 1.05418 7.89062C0.471974 7.89062 0 8.3626 0 8.94481C0 9.52702 0.471974 9.99899 1.05418 9.99899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16161 6.05759C5.74382 6.05759 6.21579 5.58561 6.21579 5.0034C6.21579 4.42119 5.74382 3.94922 5.16161 3.94922C4.5794 3.94922 4.10742 4.42119 4.10742 5.0034C4.10742 5.58561 4.5794 6.05759 5.16161 6.05759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16161 2.10837C5.74382 2.10837 6.21579 1.63639 6.21579 1.05418C6.21579 0.471974 5.74382 0 5.16161 0C4.5794 0 4.10742 0.471974 4.10742 1.05418C4.10742 1.63639 4.5794 2.10837 5.16161 2.10837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16161 9.99899C5.74382 9.99899 6.21579 9.52702 6.21579 8.94481C6.21579 8.3626 5.74382 7.89062 5.16161 7.89062C4.5794 7.89062 4.10742 8.3626 4.10742 8.94481C4.10742 9.52702 4.5794 9.99899 5.16161 9.99899Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixDot);
export default __webpack_public_path__ + "static/media/sixDot.c0f4106601a1944b2860b691335dc48f.svg";
export { ForwardRef as ReactComponent };